export async function createTransaction(transactionData: {
  name: string;
  amount: string;
  date: string;
  category?: string;
  externalId?: string;
  source?: string;
  propertyId?: string | null; // Optional, can be null if not provided
  organizationId: string; // Required organization ID
}) {
  try {
    const response = await fetch("/api/transactions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...transactionData,
        propertyId: transactionData.propertyId || null, // Convert undefined to null
      }),
    });
    if (!response.ok) {
      throw new Error("Error creating transaction");
    }
    const data = await response.json();

    return data.transaction;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
